// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.warning-flag {
	color: red;
	padding:5px;
}`, "",{"version":3,"sources":["webpack://./client/javascript/common/indicators.css"],"names":[],"mappings":"AAAA;CACC,UAAU;CACV,WAAW;AACZ","sourcesContent":[".warning-flag {\n\tcolor: red;\n\tpadding:5px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
